export default "__VITE_ASSET__B259bsL7__"